import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCallout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.56239 11.4514L8.13626 12.6882C8.50569 13.3496 8.22031 14.1608 7.5 14.5C6.77969 14.8392 5.89617 14.5772 5.52673 13.9158L3.23077 10.1538",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 4L3.5 4C1.843 4 0.5 5.343 0.5 7C0.5 8.657 1.843 10 3.5 10L8 10C11 10 14.5 13 14.5 13V1C14.5 1 11 4 8 4Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIconCallout;
